import { CompetitionTeamListQueryParams, useCompetitionTeamListQuery } from '../queries';
import { BaseFormState } from '~/types/BaseFormState';
import { Input, SelectProps } from '~/components/Input';
import { ForwardedRef, forwardRef } from 'react';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & {
  competitionId: number;
  query?: Omit<Exclude<CompetitionTeamListQueryParams, undefined>, 'competition' | 'page_size'>;
};

function CompetitionTeamSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { competitionId, query, ...rest } = props;
  const { data, isLoading } = useCompetitionTeamListQuery({ competition: competitionId, page_size: 999, ...query });

  return (
    <Input.Select
      placeholder={props.placeholder ?? 'Välj lag'}
      aria-label={props['aria-label'] ?? 'Lag'}
      options={data?.results.map(t => [`${t.division.name} — ${t.name}`, t.id]) ?? []}
      disabled={isLoading}
      ref={ref}
      {...rest}
    />
  );
}

export const CompetitionTeamSelect = forwardRef(CompetitionTeamSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof CompetitionTeamSelectElement>;
